import { render } from "./search-overview.vue?vue&type=template&id=5de7e595"
import script from "./search-overview.vue?vue&type=script&lang=js"
export * from "./search-overview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__